// extracted by mini-css-extract-plugin
export default {"errorLabel":"styles_errorLabel__zPCsP","error":"styles_error__3P6a9"};